import confetti from 'canvas-confetti';

const CONFETTI_COLORS = [
  '#ff0000',
  '#ff4500',
  '#ffa500',
  '#ffd700',
  '#ffff00',
  '#32cd32',
  '#00ff7f',
  '#00ced1',
  '#1e90ff',
  '#4169e1',
  '#7b68ee',
  '#9370db',
  '#ff00ff',
  '#ff1493',
];

const noCleanup = () => {};
const randomInRange = (min, max) => Math.random() * (max - min) + min;

const startCelebrationConfetti = ({
  canvasClassName,
  sideParticleCount,
  centerParticleCount,
  burstInterval,
  burstDuration,
  settleDuration,
  scalar,
}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return noCleanup;

  const canvas = document.createElement('canvas');
  canvas.className = canvasClassName;
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  let burstTimer = null;
  let stopTimer = null;
  let settleTimer = null;
  let cleaned = false;
  let fire = null;
  let lastAnimationPromise = null;

  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    window.clearInterval(burstTimer);
    window.clearTimeout(stopTimer);
    window.clearTimeout(settleTimer);
    fire?.reset?.();
    canvas.remove();
  };

  try {
    fire = confetti.create(canvas, {
      disableForReducedMotion: false,
      resize: true,
      useWorker: true,
    });
  } catch (error) {
    cleanup();
    return noCleanup;
  }

  const emit = (options) => {
    const animationPromise = fire(options);
    if (animationPromise && typeof animationPromise.then === 'function') {
      lastAnimationPromise = animationPromise;
    }
  };

  const fireBurst = () => {
    const commonOptions = {
      colors: CONFETTI_COLORS,
      decay: 0.92,
      gravity: 0.86,
      scalar,
      ticks: 220,
    };

    emit({
      ...commonOptions,
      particleCount: sideParticleCount,
      startVelocity: 42,
      spread: 74,
      drift: 0.14,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    emit({
      ...commonOptions,
      particleCount: sideParticleCount,
      startVelocity: 42,
      spread: 74,
      drift: -0.14,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
    });
    emit({
      ...commonOptions,
      particleCount: centerParticleCount,
      startVelocity: 48,
      spread: 96,
      drift: 0.04,
      origin: { x: 0.5, y: Math.random() - 0.3 },
    });
  };

  fireBurst();
  burstTimer = window.setInterval(fireBurst, burstInterval);
  stopTimer = window.setTimeout(() => {
    window.clearInterval(burstTimer);
    burstTimer = null;
    canvas.classList.add('is-fading');
    settleTimer = window.setTimeout(cleanup, settleDuration);
    lastAnimationPromise?.then(cleanup, cleanup);
  }, burstDuration);

  return cleanup;
};

export const startDurationCouponConfetti = () => startCelebrationConfetti({
  canvasClassName: 'tvup-duration-confetti-canvas',
  sideParticleCount: 8,
  centerParticleCount: 5,
  burstInterval: 100,
  burstDuration: 2800,
  settleDuration: 4400,
  scalar: 0.96,
});

export const startReferralBonusConfetti = () => startCelebrationConfetti({
  canvasClassName: 'tvup-referrals-confetti-canvas',
  sideParticleCount: 16,
  centerParticleCount: 10,
  burstInterval: 80,
  burstDuration: 3400,
  settleDuration: 4800,
  scalar: 1,
});
